<template>
    <div id="Search" class="starter-template">

        <div class="text-center">
            <b-spinner variant="primary" class="align-middle" v-if="loading" style="position:absolute;top:50%"></b-spinner>
        </div>

        <b-container>
            <b-table class="backWhite descOuter"
                    id="listTable"
                    ref="itemList"
                     selectable
                    :items="items"
                    :fields="fields"
                    :key="myKey"
                    striped
                    :per-page=0
                    :current-page="curPage"
                    head-row-variant="info"
                    @row-selected="onRowSelected"
            >
            </b-table>

            <b-pagination
                    v-model="curPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="listTable"
                    pills
            ></b-pagination>

        </b-container>

        <b-container fluid class="footer text-center">
        </b-container>

    </div>
</template>

<script>
import { BContainer, BSpinner, BPagination, BTable } from 'bootstrap-vue';

export default {
  name: 'Search',
  components: {
    BContainer, BSpinner, BPagination, BTable
  },
  data: function() {
    return {
        fields: [
          {
            key: 'itemName',
            label: this.$t('TITLE'),
            sortable: true
          },

          {
            key: 'itemTypeExt',
            label: this.$t('TYPE'),
            sortable: true
          },
          {
            key: 'userName',
            label: this.$t('AUTHOR'),
            sortable: true
          },
          {
            key: 'pubDate',
            label: this.$t('DATE_PUB'),
            sortable: true
          }
        ],
        myKey: 0,
        key: 0,
        perPage: 10,
        curPage: 1,
        items: [{}],
        tblName: '',
        searchTxt: '',
        res: '',
        listLength: 1,
        loading: false
    }
  },
  mounted() {
    this.searchTxt = this.$rmEncHyp(this.$route.query.searchTxt);
    this.search();
  },
  methods: {
    async search() {
        try {
            this.loading = true;
            const response = await this.$http.get('search', {
                params: {
                    searchTxt: this.searchTxt,
                    pageNum: this.curPage
                }
            });
            this.loading = false;
            if((typeof response.data.itemList) === 'undefined')
                this.$showMsg(this.$t('NOT_FOUND'));
            else {
                this.items = response.data.itemList;
                this.listLength = response.data.listLen;
                for(let i=0; i<this.items.length; i++)
                    if(this.items[i].itemType[0]==='t') this.items[i].itemTypeExt = this.$t('TRIP');
                    else if(this.items[i].itemType[0]==='p') this.items[i].itemTypeExt = this.$t('PLACE');
                    else this.items[i].itemTypeExt = this.$t('OUTING');
            }
        }
        catch(error) {
            this.loading = false;
            if(typeof error.response === 'undefined') this.$serveErr('Search: search() '+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
    },
    onRowSelected(items) {
        this.item = items[0];
        let itemName = this.$addEncHyp(this.item.itemName);
        let userName = this.$addEncHyp(this.item.userName);
        let itemType = this.item.itemType;
        if(itemType[0] == 'p')
            this.$router.push({
                path: '/Place/'+itemName+'/'+userName
            })
        else if(itemType[0] == 't')
            this.$router.push({
                path: '/Tour/'+itemName+'/'+userName
            })
        else
            this.$router.push({
                path: '/Outing/'+itemName+'/'+userName
            })
    }
  },
  watch: {
      curPage: function(value) {
        this.search(value);
      },

      curLang: function() {
        //alert(this.$i18n.locale);
      }

  },
  computed: {
    rows() {
        return this.listLength;
    }
  }

}

</script>

<style>
</style>